import { useTranslation } from 'react-i18next';

export const clientSteps = (): string[] => {
  const { t } = useTranslation();

  const clientStepsList = [
    t('registerClient.step1'),
    t('registerClient.step2'),
    t('registerClient.step3'),
    t('registerClient.step4'),
    t('registerClient.step5')
  ];

  return clientStepsList;
};

export const agentSteps = (): string[] => {
  const { t } = useTranslation();

  const agentStepsList = [
    t('agentClient.step1'),
    t('agentClient.step2'),
    t('agentClient.step3')
  ];

  return agentStepsList;
};

export const agentClientRegisterSteps = (): string[] => {
  const { t } = useTranslation();

  const agentClientRegisterStepsList = [
    t('registerClient.step1'),
    t('registerClient.step2-agent'),
    t('registerClient.step3'),
    t('registerClient.step4'),
    t('registerClient.step5')
  ];

  return agentClientRegisterStepsList;
};

export const publisherMediaRegisterEditSteps = (): string[] => {
  const { t } = useTranslation();

  const publisherMediaRegisterEditStepsList = [
    t('publisherMediaRegisterEdit.step1'),
    t('publisherMediaRegisterEdit.step2'),
    t('publisherMediaRegisterEdit.step3'),
    t('publisherMediaRegisterEdit.step4')
  ];

  return publisherMediaRegisterEditStepsList;
};
